(function () {
  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function adjustBodyOffset(banner) {
    var isSticky = banner.classList.contains('sale-countdown-banner--sticky');
    var isVisible = banner.style.display !== 'none';

    if (isSticky && isVisible) {
      document.body.style.paddingTop = banner.offsetHeight + 'px';
    } else {
      document.body.style.paddingTop = '';
    }
  }

  function escapeToBody(banner) {
    if (banner.parentElement !== document.body) {
      document.body.insertBefore(banner, document.body.firstChild);
    }
  }

  function initTimer(banner) {
    if (banner.dataset.saleCountdownInit === 'true') return;
    banner.dataset.saleCountdownInit = 'true';

    if (banner.classList.contains('sale-countdown-banner--sticky')) {
      escapeToBody(banner);
    }

    var timerEl = banner.querySelector('[data-sale-countdown-timer]');
    if (!timerEl) {
      adjustBodyOffset(banner);
      window.addEventListener('resize', function () {
        adjustBodyOffset(banner);
      });
      return;
    }

    var dateStr = banner.getAttribute('data-end-date');
    var timeStr = banner.getAttribute('data-end-time') || '23:59';
    if (!dateStr) return;

    var dateParts = dateStr.split('-').map(Number);
    var timeParts = timeStr.split(':').map(Number);

    if (dateParts.length !== 3 || isNaN(dateParts[0])) return;

    var endDate = new Date(
      dateParts[0],
      dateParts[1] - 1,
      dateParts[2],
      timeParts[0] || 23,
      timeParts[1] || 59,
      0
    );

    var timerTextEl = timerEl;

    function tick() {
      var distance = endDate.getTime() - Date.now();

      if (distance <= 0) {
        banner.style.display = 'none';
        clearInterval(intervalId);
        adjustBodyOffset(banner);
        return;
      }

      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));

      if (timerTextEl) {
        var parts = [];
        if (days > 0) parts.push(days + 'T');
        parts.push(pad(hours) + 'Std');
        parts.push(pad(minutes) + 'Min');
        timerTextEl.textContent = parts.join(' ');
      }
    }

    tick();
    var intervalId = setInterval(tick, 20000);

    adjustBodyOffset(banner);
    window.addEventListener('resize', function () {
      adjustBodyOffset(banner);
    });
  }

  function initAll() {
    document.querySelectorAll('.sale-countdown-banner').forEach(initTimer);
  }

  document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('body > .sale-countdown-banner').forEach(function (el) {
      el.remove();
    });
    initAll();
  });
})();